import { render, staticRenderFns } from "./ListsTournament.vue?vue&type=template&id=cead98fa&scoped=true"
import script from "./ListsTournament.vue?vue&type=script&lang=js"
export * from "./ListsTournament.vue?vue&type=script&lang=js"
import style0 from "./ListsTournament.vue?vue&type=style&index=0&id=cead98fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cead98fa",
  null
  
)

export default component.exports